import React, { useContext, useEffect, useState } from 'react';
import { TextField, Button, Snackbar, Grid, Typography, Modal, FormControl, InputLabel, MenuItem, Select, Box } from '@mui/material';
import { Alert } from '@mui/lab';
import axios from 'axios';
import CollapsibleTable from './CollapsibleTable';
import AppContext from '../context/AppContext';
import { DataGrid, GridToolbar, GridFilterPanel } from '@mui/x-data-grid';

const UpdateAlert = () => {
  const storedUserRole = localStorage.getItem('userRole');
  const [alert, setAlerts] = useState([])
  const [currentAlert, setCurrentAlert] = useState({
    id: "",
    value: "",
  });
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const [new_alert, setnewAlert] = useState("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/report/get/alerts`,

        );
        if (response.data.status == 'success') {
          setAlerts(response.data.alerts)
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [openModalUpdate])

  const handleCloseModalUpdate = (row) => {
    setOpenModalUpdate(false);
  };

  const handleUpdateModal = (row, id) => {
    setCurrentAlert({
      id: id,
      value: row,
    });
    setOpenModalUpdate(true);
  };

  const usercolumns = [
    {
      field: "id",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "value",
      width: 310,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Alert Time"}</strong>
      ),
      renderCell: (params) => {
        return <Typography id={params.id}>{params.value}</Typography>;
      },
    },
    {
      field: "updateButton",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}></strong>
      ),
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{ borderRadius: 25, fontSize: 11 }}
          id={params.row.updateButton}
          onClick={() => handleUpdateModal(params.row.value, params.row.id)}
        >
          Update
        </Button>
      ),
    },

  ];

  const handleUpdateButton = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/v1/put/update/alert`,
        {
          alert_time: new_alert,
        }
      );

      setError(response.data.message);
      setOpen(true);
      setMessage(response.data.message);
      setSeverity("success");
      setOpenModalUpdate(false);
    } catch (err) {
      setMessage(error.response.data.error || "Failed to add category");
      setSeverity("error");
      setError("some error occured, please Try again");
      setOpen(true);
      setOpenModalUpdate(false);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DataGrid
            getRowId={(row) => row.value}
            rows={alert.map((alerts, index) => ({
              id: alerts.id,
              value: alerts.alert,
              updateButton: `update-${index}`,
            }))}
            columns={usercolumns}
            pageSize={10}
            rowSelection={false}
            rowsPerPageOptions={[10, 20, 30]}
            components={{
              Toolbar: GridToolbar,
              FilterPanel: GridFilterPanel,
            }}
            slotProps={{
              filterPanel: {
                sx: {
                  width: "100%",          // full width responsive
                  maxWidth: "100%",
                  padding: "10px",
                  "& .MuiDataGrid-filterForm": {
                    flexDirection: "column",
                    gap: "10px",
                  },
                },
              },
            }}
            pagination
          />


        </Grid>

        <Modal
          open={openModalUpdate}
          onClose={handleCloseModalUpdate}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",

              width: isMobile ? 300 : 600,
              maxHeight: "100%",

              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "white",
              boxShadow: 24,
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "flex-end",
                cursor: "pointer",
                padding: "20px",
              }}
              onClick={handleCloseModalUpdate}
            >
              <img style={{ width: 20, height: 20 }} src="/Close.png" />
            </div>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
                margin: "auto",
              }}
            >
              <Grid container spacing={2} style={{ marginBottom: 13 }}>
                <Grid item xs={12}>
                  <TextField
                    disabled
                    id="outlined-disabled"
                    label="Current Alert Time"
                    defaultValue={currentAlert.value}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    label=" New Alert Time"
                    value={new_alert}
                    onChange={(e) => setnewAlert(e.target.value)}
                    style={{ width: "100%" }}
                  />
                </Grid>
              </Grid>

              <Button
                variant="contained"
                onClick={() => handleUpdateButton(currentAlert.id)}
              >
                Update
              </Button>
            </Box>
          </div>
        </Modal>

      </Grid>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UpdateAlert;
